import './LanderChat.scss';

import React, { useEffect, useState } from 'react';

export default function LanderChat({ messages, endChatAction = null, landerId }) {
  const [displayedMessages, setDisplayedMessages] = useState([]);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const landerMessageClassName = `Message13 version${landerId}`;

  useEffect(() => {
    const addMessage = () => {
      // Display a typing message
      const typingMessage = { typing: true, content: '' };
      setDisplayedMessages((prevMessages) => [...prevMessages, typingMessage]);

      // Simulate delay before showing the actual message
      setTimeout(() => {
        setDisplayedMessages((prevMessages) => {
          const updatedMessages = [...prevMessages];
          updatedMessages.pop(); // Remove the typing message
          updatedMessages.push(messages[currentMessageIndex]); // Add the actual message
          return updatedMessages;
        });
        setCurrentMessageIndex((prevIndex) => prevIndex + 1);

        // Check if it's the last message and perform endChatAction if defined
        if (currentMessageIndex + 1 === messages.length) {
          endChatAction && endChatAction();
        }
      }, 600);
    };

    if (currentMessageIndex == 0) {
      addMessage();
    }

    const timer = setInterval(() => {
      if (currentMessageIndex < messages.length) {
        addMessage();
      } else {
        clearInterval(timer);
      }
    }, 900);

    return () => {
      clearInterval(timer);
    };
  }, [currentMessageIndex]);

  return (
    <div className="ChatContainer13">
      {displayedMessages.map((message, index) => (
        <div
          className="MessageContainer ToggleElement"
          style={{ animationDelay: `${index * 0.2}s` }}
          key={index}
        >
          <div className={landerMessageClassName}>
            {message.typing && (
              <div className="typing is-typing-init is-typing-active">
                <span className="typing__bullet"></span>
                <span className="typing__bullet"></span>
                <span className="typing__bullet"></span>
              </div>
            )}
            <div dangerouslySetInnerHTML={{ __html: message.content }} />
          </div>
        </div>
      ))}
    </div>
  );
}
